import { render, staticRenderFns } from "./personnel.vue?vue&type=template&id=4b39b81a&scoped=true&"
import script from "./personnel.vue?vue&type=script&lang=js&"
export * from "./personnel.vue?vue&type=script&lang=js&"
import style0 from "./personnel.vue?vue&type=style&index=0&id=4b39b81a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b39b81a",
  null
  
)

export default component.exports